import { API_URL, getCachedSessionId } from 'src/services/common';
import { api } from '../../../../util/axios-instance';
import { FetchProjectsResponseData } from '../interfaces/fetchProjects.interface';

export const fetchProjects = async (): Promise<FetchProjectsResponseData | undefined> => {
  const response = await api.get<FetchProjectsResponseData>(`${API_URL}/v1/project?limit=200`, {
    headers: { 'x-session-id': getCachedSessionId() }
  });
  return response.data;
};
